<template>
  <div class="order_details" v-loading.fullscreen.lock="loading">
    <breadcrumb :breadcrumb="crumbList"></breadcrumb>
    <div class="order_details_header">
      <div>
        <span>订单编号：{{orderDetails.order_code}}</span>
        <span class="order_details_header_type">{{type[orderStatus]}}</span>
      </div>
      <div>
        <el-button type="primary" size="small"
          v-if="orderDetails.status == 2 || orderDetails.status == 3  || orderDetails.status == 4 "
          @click="is_modal = true">查看电子运单</el-button>
        <el-button type="" size="small"
          v-if="orderDetails.status == 2 || orderDetails.status == 3  || orderDetails.status == 4 " @click="gobiaopian">
          打印标签</el-button>
      </div>
    </div>
    <div class="order_details_address">
      <div class="order_details_address_start">
        <div class="order_details_address_start_logo">寄</div>
        <div>
          <div class="order_details_address_start_phone">
            <span>{{orderDetails.sender}}</span>
            <span style="margin-left:10px">{{orderDetails.start_phone_hide}}</span>
          </div>
          <div class="order_details_address_start_company">
            {{orderDetails.start}}
          </div>
        </div>
      </div>
      <div style="border-bottom:1px solid #E1E1E1;width:638px;margin-left:60px;margin-top:22px;margin-bottom:16px">
      </div>
      <div class="order_details_address_line"></div>
      <div class="order_details_address_end">
        <div class="order_details_address_end_logo">收</div>
        <div>
          <div class="order_details_address_end_company">
            {{orderDetails.end}}
          </div>
        </div>
      </div>
    </div>
    <div class="order_details_msg">
      <div class="order_details_title">物品信息</div>
      <div class="order_details_box">
        <div class="order_details_msg_left">
          <div class="order_details_msg_left_item">
            <div class="order_details_msg_left_item_title">托运方式</div>
            <div class="order_details_msg_left_item_value">{{deliveryTypeList[orderDetails.delivery_type]}}</div>
          </div>
          <div class="order_details_msg_left_item">
            <div class="order_details_msg_left_item_title">物品类型</div>
            <div class="order_details_msg_left_item_value">{{orderDetails.item_type}}</div>
          </div>
          <div class="order_details_msg_left_item">
            <div class="order_details_msg_left_item_title">物品重量</div>
            <div class="order_details_msg_left_item_value">{{orderDetails.weight}}kg</div>
          </div>
          <div class="order_details_msg_left_item">
            <div class="order_details_msg_left_item_title">物品件数</div>
            <div class="order_details_msg_left_item_value">{{orderDetails.goods_num}}件</div>
          </div>
          <div class="order_details_msg_left_item">
            <div class="order_details_msg_left_item_title">备注</div>
            <div class="order_details_msg_left_item_value">{{orderDetails.remark}}</div>
          </div>
        </div>
        <div class="order_details_msg_right">
          <div class="order_details_msg_right_item">
            <div class="order_details_msg_right_item_title">包装</div>
            <div class="order_details_msg_right_item_value">{{orderDetails.pack.join('、')}}</div>
          </div>
          <div class="order_details_msg_right_item">
            <div class="order_details_msg_right_item_title">物品体积</div>
            <div class="order_details_msg_right_item_value">{{orderDetails.volume}}m³</div>
          </div>
          <div class="order_details_msg_right_item">
            <div class="order_details_msg_right_item_title">保价</div>
            <div class="order_details_msg_right_item_value">¥200,00</div>
          </div>
          <div class="order_details_msg_right_item">
            <div class="order_details_msg_right_item_title">增值服务</div>
            <div class="order_details_msg_right_item_value"><span>{{orderDetails.added_serviceStr}}</span></div>
          </div>
          <div class="order_details_msg_right_item">
            <div class="order_details_msg_right_item_title">物品照片</div>
            <div class="order_details_msg_right_item_value">
              <img v-for="(item,index) in orderDetails.imageurl" @click="showImg(index)" :key="index"
                :src="$imgUrl + item" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="order_details_cost">
      <div style="width:360px;">
        <div class="order_details_cost_left">
          <div class="order_details_title">费用明细</div>
          <div class="order_details_cost_box">
            <div class="order_details_cost_box_item">
              <div class="order_details_cost_box_item_title">运费</div>
              <div class="order_details_cost_box_item_value">¥{{orderDetails.base}}</div>
            </div>
            <div class="order_details_cost_box_item">
              <div class="order_details_cost_box_item_title">保价</div>
              <div class="order_details_cost_box_item_value">¥{{orderDetails.policy}}</div>
            </div>
            <div class="order_details_cost_box_item">
              <div class="order_details_cost_box_item_title">增值服务</div>
              <div class="order_details_cost_box_item_value">¥{{orderDetails.added_service_price}}</div>
            </div>
            <div class="order_details_cost_box_item">
              <div class="order_details_cost_box_item_title">使用优惠券</div>
              <div class="order_details_cost_box_item_value">-¥{{orderDetails.coupon_reduce_price}}</div>
            </div>
            <div class="order_details_cost_box_item">
              <div class="order_details_cost_box_item_title">平台服务费</div>
              <div class="order_details_cost_box_item_value">¥{{orderDetails.rebate_price}}</div>
            </div>
          </div>
          <div class="order_details_cost_left_line"></div>
          <div class="order_details_cost_left_all">¥{{orderDetails.price}}</div>
        </div>
        <div class="order_details_cost_action">
          <el-button size="small" v-for="(item,index) in btnList[orderStatus]" :key="index" :type="item.type"
            @click="btnClick(item.clickName)">
            <span v-if="item.btnName == '评价'">{{orderDetails.is_comment == 1 ? '查看评价' : '评价'}}</span>
            <span v-else>{{item.btnName}}</span>
          </el-button>
        </div>
      </div>
      <div class="order_details_cost_right" v-if="orderStatus != 0">
        <div class="order_details_title">其他信息</div>
        <div class="order_details_cost_box">
          <div class="order_details_cost_box_item">
            <div class="order_details_cost_box_item_title">师傅姓名</div>
            <div class="order_details_cost_box_item_value">{{orderDetails.driver_info.username}}</div>
          </div>
          <div class="order_details_cost_box_item" v-if="orderDetails.delivery_type == 1">
            <div class="order_details_cost_box_item_title">货车类型</div>
            <div class="order_details_cost_box_item_value">
              {{orderDetails.driver_info.vehicle_type}}/车长{{orderDetails.driver_info.vehicle_length}}m/{{orderDetails.driver_info.vehicle_model_number.join('、')}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-image-viewer v-if="showViewer" :on-close="()=>{showViewer=false}" :url-list="imgList" />
    <abnormal v-if="abnormalVisible" :abnormalVisible.sync="abnormalVisible" :item="orderDetails"
      @abnormalCallback="abnormalCallback"></abnormal>
    <evaluate v-if="evaluateVisible" :evaluateData="evaluateData" :evaluateVisible.sync="evaluateVisible"
      :details="orderDetails" @evaluateCallback="evaluateCallback"></evaluate>
    <driverModal v-if="driverVisible" :driverVisible.sync="driverVisible" :driverCallback="driverCallback"
      :item="orderDetails"></driverModal>
    <phoneModal v-if="phoneVisible" :phoneVisible.sync="phoneVisible" :selectItem="phoneItem"></phoneModal>
    <abnormalResult v-if="abnormalResultVisible" :abnormalResultVisible.sync="abnormalResultVisible"
      :details="abnormalResultData"></abnormalResult>
    <mapTrack v-if="mapTrackVisible" :mapTrackVisible.sync="mapTrackVisible" :addressData="addressData"></mapTrack>
    <el-dialog title="选择支付方式" :visible.sync="payVisible" width="400px" class="pay_modal" :before-close="payHandleClose">
      <div>
        <!-- <el-checkbox v-model="pay_wx" class="pay_modal_cbox"><div class="pay_modal_wx"><img src="../../assets/order/pay_wx.png" alt=""> 微信支付</div></el-checkbox> -->
        <el-radio v-model="pay_wx" :label="1" class="pay_modal_cbox">
          <div class="pay_modal_wx"><img src="../../assets/order/pay_wx.png" alt=""> 微信支付</div>
        </el-radio>
      </div>
      <div style="margin-top:20px">
        <!-- <el-checkbox v-model="pay_yuer">余额支付&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;当前余额¥{{money_num}}</el-checkbox> -->
        <el-radio v-model="pay_wx" :label="3">余额支付&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;当前余额¥{{money_num}}</el-radio>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="payVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="payConfirm" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="微信支付" :visible.sync="wxVisible" width="300px" class="wx_modal" append-to-body
      :before-close="wxHandleClose">
      <div style="text-align:center">
        <div style="color:#333;font-size:16px">请扫码支付</div>
        <img :src="pay_url" style="width:200px" alt="">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wxVisible = false" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- @touchmove.prevent @mousewheel.prevent -->
    <div class="modal" @click="is_modal = false" @touchmove.prevent @mousewheel.prevent v-if="is_modal"></div>

    <div class="modal_box" v-if="is_modal">
      <div style="text-align:right;margin-bottom:10px;padding:20px 20px 0 20px">
        <el-button size="small" @click="$router.go(-1)">关闭</el-button>
        <el-button size="small" type="primary" @click="downloadOrder">下载</el-button>
      </div>
      <div style="padding: 20px;" id="demo">
        <div class="modal_content">
          <div style="display: flex;height: 100px;">
            <div style="width: 40%;margin-top: 10px;margin-left: 20px;">
             <!-- <img src="../../assets/logo2.png" alt="" style="width: 80px;height: 80px;"> -->
            </div>
            <div style="width: 60%;font-size: 18px;color: #000;margin-top: 25px;font-weight: initial;word-spacing:20px;letter-spacing: 6px;">
              <span style="display: inline-block;margin-right: 50px;">日期</span>
              <span>{{getDate(orderDetails.create_time)}}</span>

          <!--   <div style="margin-left: 60%;line-height: 10px;width: 39%;text-align: right;font-size: 25px;color: #409eff;">
               No:
             </div> -->
            </div>
          </div>


         <div class="gods1">
         <!--  <div class="gods1_prd">
             派件网点存根
           </div> -->
          <div class="title_2" >
            <el-row>
              <el-col :span="10">
                <div class="grid-content bg-purple"><!-- 1、托运人信息 --></div>
              </el-col>
              <el-col :span="14">
                <div class="grid-content bg-purple-light"><!-- 4、服务 --></div>
              </el-col>
            </el-row>
          </div>

          <div class="imtes_2">
            <el-row>
              <el-col :span="10">
                <div class="grid-content bg-purple bg-purple_2"><!-- 托运人/公司: -->{{orderDetails.sender}}</div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-checkbox v-model="checked"><!-- 自提 --></el-checkbox>
                </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-checkbox v-model="checked"><!-- 等通知送货 --></el-checkbox>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="imtes_2">
            <el-row>
              <el-col :span="10">
                <div class="grid-content bg-purple"><!-- 电话: -->{{orderDetails.start_phone}}</div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-checkbox v-model="checked"><!-- 送货 --></el-checkbox>
                </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple-light">
                  <el-checkbox v-model="checked"><!-- 签回单 --></el-checkbox>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="imtes_2">
            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple"><!-- 地址: -->{{orderDetails.start}}</div>
              </el-col>
            </el-row>
          </div>
           </div>
            <!-- -->
 <div class="gods1">

   <!-- <div class="gods1_prd">
      发货客户存根
    </div>

      <div class="gods1_prd2">
        收货人签名:
    </div> -->
          <div class="title_2">
            <el-row>
              <el-col :span="10">
                <div class="grid-content bg-purple"><!-- 2、收件人信息 --></div>
              </el-col>
              <el-col :span="14">
                <div class="grid-content bg-purple-light"><!-- 5、代收 --></div>
              </el-col>
            </el-row>
          </div>

          <div class="imtes_2">
            <el-row>
              <el-col :span="10">
                <div class="grid-content bg-purple bg-purple_2"><!-- 托运人/公司: -->{{orderDetails.end_owner_name || '无托运人'}}</div>
              </el-col>
              <el-col :span="14">
                <div class="grid-content bg-purple-light"><!-- 代收货款： --></div>
              </el-col>

            </el-row>
          </div>
          <div class="imtes_2">
            <el-row>
              <el-col :span="10">
                <div class="grid-content bg-purple"><!-- 电话: -->{{orderDetails.end_phone}}</div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple-light"><!-- 声名价值: -->{{orderDetails.goods_value}} </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple-light"> <!-- 保险费: -->{{orderDetails.insured_price}}</div>
              </el-col>
            </el-row>
          </div>
          <div class="imtes_2">
            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple"><!-- 地址: -->{{orderDetails.end}}</div>
              </el-col>
            </el-row>
          </div>

          <div class="imtes_2">
            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple" style="height: 24px;"><!-- 备注: --></div>
              </el-col>
            </el-row>
          </div>

          </div>
          <!-- -->
        <div class="gods1">
         <!-- <div class="gods1_prd">
            分拣网点存根
          </div>
          <div class="gods1_prd3">
              托运人签名:
          </div> -->
          <div class="title_2">
            <el-row>
              <el-col :span="10">
                <div class="grid-content bg-purple"><!-- 3、货物基本信息 --></div>
              </el-col>
              <el-col :span="14">
                <div class="grid-content bg-purple-light"><!-- 4、费用 --></div>
              </el-col>
            </el-row>
          </div>

          <div class="imtes_2">
            <el-row>
              <el-col :span="5">
                <div class="grid-content bg-purple"><!-- 品名: -->{{orderDetails.item_type}}</div>
              </el-col>
              <el-col :span="5">
                <div class="grid-content bg-purple"><!-- 件数: -->{{orderDetails.goods_num}}件</div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple-light">
                  <el-checkbox disabled  v-model="settlement_type_0"><!-- 现付 --></el-checkbox>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple-light">
                  <el-checkbox disabled v-model="settlement_type_1"><!-- 到付 --></el-checkbox>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="grid-content bg-purple-light">
                  <el-checkbox disabled v-model="settlement_type_2"><!-- 月结 --></el-checkbox>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="imtes_2">
            <el-row>
              <el-col :span="5">
                <div class="grid-content bg-purple"><!-- 包装: -->{{orderDetails.pack.join('、') || '无包装'}}</div>
              </el-col>
              <el-col :span="5">
                <div class="grid-content bg-purple"><!-- 体积: -->{{orderDetails.volume}}m³</div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple"><!-- 运费 :-->￥{{orderDetails.base}}</div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple"><!-- 送货费 :--></div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple"><!-- 提货费 :--></div>
              </el-col>
            </el-row>
          </div>


          <div class="imtes_2">
            <el-row>
              <el-col :span="10">
                <div class="grid-content bg-purple"><!-- 重量: -->{{orderDetails.weight}}kg</div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple"><!-- 其它费用: -->￥{{orderDetails.pack_price}}</div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple"><!-- 卸货费: --></div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple">合计:￥{{orderDetails.price}}</div>
              </el-col>
            </el-row>
          </div>

          <div class="imtes_2" v-if="orderDetails.custom_commission_price<=0">
            <el-row>
              <el-col :span="10">
                <div class="grid-content bg-purple"><!-- 佣金 -->{{orderDetails.custom_commission_price}}</div>
              </el-col>

            </el-row>
          </div>

        </div>



        </div>

      </div>

    </div>
    <orderPrint ref="orderPrintRef" :datas="orderDetails"></orderPrint>
  </div>
</template>

<script>
  // import downloadPDF from '@/utils/downLoadPDF.js'
  import downloadPDF from '../../utils/downloadPDF'
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
  import breadcrumb from '@/components/breadcrumb'
  import abnormal from './components/abnormal'
  import orderPrint from './components/orderPrint'
  import abnormalResult from './components/abnormalResult'

  import driverModal from '../orderList/components/driverModal'
  import phoneModal from '../orderList/components/phoneModal'
  import evaluate from './components/evaluate.vue'
  import mapTrack from './components/mapTrack'
  export default {
    data() {
      return {
        crumbList: [{
            name: '个人中心',
            path: '/message'
          },
          {
            name: '我的订单',
            path: '/orderList'
          },
          {
            name: '订单详情',
            path: '/orderDetails'
          }
        ],
        imgList: [],
        settlement_type_0:false,
        settlement_type_1:false,
        settlement_type_2:false,
        checked: false,
        type: {
          0: '待接单',
          1: '待取货',
          2: '运输中',
          3: '待支付',
          4: '已完成',
          5: '已取消',
          6: '异常'
        },
        showViewer: false,
        //    按钮状态
        btnList: {
          0: [{
              btnName: '司机列表',
              type: 'primary',
              clickName: 'selectDriver'
            },
            {
              btnName: '联系客服',
              type: '',
              clickName: 'getCustomerPhone'
            },
            {
              btnName: '取消订单',
              type: '',
              clickName: 'cancelOrder'
            },
          ],
          1: [{
              btnName: '联系司机',
              type: 'primary',
              clickName: 'getPhone'
            },
            {
              btnName: '更换司机',
              type: '',
              clickName: 'selectDriver'
            },
            {
              btnName: '联系客服',
              type: '',
              clickName: 'getCustomerPhone'
            },
            {
              btnName: '取消订单',
              type: '',
              clickName: 'cancelOrder'
            },
          ],
          2: [{
              btnName: '物流跟踪',
              type: 'primary',
              clickName: 'logisticsTrack'
            },
            {
              btnName: '联系司机',
              type: '',
              clickName: 'getPhone'
            },
            {
              btnName: '联系客服',
              type: '',
              clickName: 'getCustomerPhone'
            },
          ],
          3: [{
              btnName: '立即支付',
              type: 'primary',
              clickName: 'submitPay'
            },
            {
              btnName: '物流跟踪',
              type: '',
              clickName: 'logisticsTrack'
            },
            {
              btnName: '联系客服',
              type: '',
              clickName: 'getCustomerPhone'
            },
            {
              btnName: '联系司机',
              type: '',
              clickName: 'getPhone'
            },
          ],
          4: [{
              btnName: '联系客服',
              type: '',
              clickName: 'getCustomerPhone'
            },
            {
              btnName: '评价',
              type: '',
              clickName: 'submitEvaluate'
            },
            {
              btnName: '物流跟踪',
              type: '',
              clickName: 'logisticsTrack'
            },
            {
              btnName: '提交异常',
              type: '',
              clickName: 'submitAbnormal'
            },
          ],
          5: [{
            btnName: '联系客服',
            type: '',
            clickName: 'getCustomerPhone'
          }, ],
          6: [{
              btnName: '处理结果',
              type: 'primary',
              clickName: 'resultsTreatment'
            },
            {
              btnName: '联系客服',
              type: '',
              clickName: 'getCustomerPhone'
            },
          ]
        },
        deliveryTypeList: {
          0: '拼车',
          1: '整车'
        }, //发货类型(0拼车 1整车)
        abnormalVisible: false,
        driverVisible: false,
        phoneVisible: false,
        phoneItem: {},
        selectItem: {},
        orderId: '',
        loading: false,
        orderDetails: {
          driver_info: {},
          pack: []
        },
        goodsTypeListObj: {}, //物品类型
        servicesTypeListObj: {}, //    增值服务类型
        orderStatus: '',
        abnormalResultData: {},
        abnormalResultVisible: false,
        evaluateVisible: false,
        evaluateData: null,
        mapTrackVisible: false,
        addressData: {},
        payVisible: false,
        pay_wx: false,
        wxVisible: false,
        pay_yuer: '',
        money_num: '',
        pay_wx: 1,
        pay_url: '',
        payData: {},
        timer: null,
        is_modal: false,
        phone: localStorage.getItem('phone')
      }
    },
    components: {
      breadcrumb,
      abnormal,
      driverModal,
      phoneModal,
      abnormalResult,
      evaluate,
      mapTrack,
      ElImageViewer,
      orderPrint
    },
    watch: {},
    computed: {

    },
    methods: {
      gobiaopian(item) {
        this.$refs.orderPrintRef.open(0);
      },
      getDate(dateStr) {
        let da = new Date(dateStr);
        var year = da.getFullYear() + '年';
        var month = da.getMonth() + 1 + '月';
        var date = da.getDate() + '日';
        return [year, month, date].join('')
      },
      downloadOrder() {
        downloadPDF(document.querySelector('#demo'), '电子托运单_' + this.orderDetails.order_code)
      },
      payHandleClose() {
        this.payVisible = false;
      },
      wxHandleClose() {
        clearInterval(this.timer);
        this.wxVisible = false;
      },
      showImg(index) {
        let imgList = [];
        // _.each(this.orderDetails.imageurl , item => {
        //     imgList.push(this.$imgUrl + item);
        // });
        for (let i = 0; i < this.orderDetails.imageurl.length; i++) {
          if (index + i < this.orderDetails.imageurl.length) {
            imgList.push(this.$imgUrl + this.orderDetails.imageurl[index + i]);
          } else {
            imgList.push(this.$imgUrl + this.orderDetails.imageurl[i - index - 1]);
          }

        }
        this.imgList = imgList;
        this.showViewer = true;
      },
      //    按钮点击转发
      btnClick(clickName) {
        this[clickName]();
      },

      getUserInfo() {

      },
      // 立即支付
      submitPay() {
        this.loading = true;
        this.$get('UserInfo', {})
          .then(data => {
            this.loading = false;
            this.money_num = data.total_money;
            this.payVisible = true;
          }, error => {
            this.loading = false;
            this.$message.error(error);
          });
      },
      payConfirm() {
        console.log(this.orderDetails)
        let params = {
          id: this.orderDetails.uuid,
          client_type: 'pc',
          is_blend_pay: '0',
          pay_type: this.pay_wx
        }
        //    if(this.pay_wx){
        //         params.pay_type = 1;
        //        if(this.pay_yuer){
        //            params.pay_type = 1;
        //        }else{
        //            params.is_blend_pay = 0;
        //        }
        //    }else{
        //        if(this.pay_yuer){
        //            this.pay_type = 3;
        //        }else{
        //            this.$message.error('请选择付款方式！')
        //            return
        //        }
        //    }
        this.loading = true;
        this.$post('OrderPay', params)
          .then(data => {
            if (this.pay_wx == 3) {
              this.$message.success('支付成功！');
              this.payVisible = false;
              this.$eventBus.$emit('getUserInfo');
              this.getDetails();
            } else {
              this.pay_url = data.qr_code_image_url;
              this.payData = data;
              this.wxVisible = true;
              this.getPayStatus();
            }
            this.loading = false;
          }, error => {
            this.loading = false;

          })
      },
      // 获取支付状态
      getPayStatus() {
        this.timer = setInterval(() => {
          if (this.timer) {
            return
          }
          this.$get('OrderPay/' + this.orderDetails.uuid)
            .then(data => {
              if (data.is_pay == 1) {
                this.wxVisible = false;
                this.payVisible = false;
                this.$message.success('支付成功！');
                this.getDetails();
                clearInterval(this.timer);
              }
            }, error => {
              this.$message.error(error)
            })
        }, 2000)
      },
      // 提交异常
      submitAbnormal() {
        this.abnormalVisible = true;
      },
      // 提交异常后的回调函数
      abnormalCallback() {
        this.getDetails();
      },
      // 物流跟踪
      logisticsTrack() {
        this.loading = true;
        this.$get('OrderLogisticsSpeed/' + this.orderDetails.uuid, {})
          .then(data => {
            this.loading = false;
            // let addressData = {
            //     start:[data.start_longitude,data.start_latitude],
            //     end:[data.end_longitude,data.end_latitude],
            //     drive:[data.drive_longitude,data,drive_latitude]
            // }
            this.addressData = data;
            console.log(data);
            this.mapTrackVisible = true;
          }, error => {
            this.loading = false;
            this.$$message.error(error);
          });
      },
      //处理结果
      resultsTreatment() {
        this.loading = true;
        this.$get('OrderExceptional/' + this.orderDetails.uuid)
          .then(data => {
            this.loading = false;
            this.abnormalResultData = data;
            this.abnormalResultVisible = true;
          }, error => {
            this.loading = false;
            this.$message.error(error);
          });
      },
      // 提交评价
      submitEvaluate() {
        if (this.orderDetails.is_comment) {
          this.loading = true;;
          this.$get('OrderComment/' + this.orderDetails.uuid, {})
            .then(data => {
              this.loading = false;
              this.evaluateData = data;
              this.evaluateVisible = true;
            }, error => {
              this.loading = false;
              this.$message.error(error);
            });
        } else {
          this.evaluateData = null;
          this.evaluateVisible = true;
        }

      },
      //    评价后的回调函数
      evaluateCallback() {
        this.getDetails();
      },
      //    选择司机
      selectDriver(item) {
        this.selectItem = item;
        this.driverVisible = true;
      },
      // 司机选择后的回调函数
      driverCallback() {
        this.getDetails();
      },

      // 取消订单
      cancelOrder() {
        this.$confirm('此操作将取消当前订单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          this.$post('OrderCancel', {
              id: this.orderDetails.uuid
            })
            .then(data => {
              this.loading = false;
              this.getDetails();
              this.$message.success('取消成功');
            }, error => {
              this.loading = false;
              this.$message.error(error)
            });
        }).catch(() => {

        });

      },
      //    获取物品类型
      getGoodsType() {
        this.$get('GoodsType', {})
          .then(data => {
            let goodsTypeListObj = {};
            _.each(data, item => {
              goodsTypeListObj[item.name] = item.name
            });
            this.goodsTypeListObj = goodsTypeListObj;
          }, error => {
            this.$message.error(error);
          });
      },
      //    获取增值服务类型
      getServicesType() {
        this.$get('AddedService', {
            type: 0
          })
          .then(data => {
            let servicesTypeListObj = {};
            _.each(data, item => {
              servicesTypeListObj[item.name] = item.name
            });
            this.servicesTypeListObj = servicesTypeListObj;
          }, error => {
            this.$message.error(error);
          });
      },
      // 联系司机
      getPhone(item) {
        this.phoneItem = {
          title: '联系方式',
          phone: this.orderDetails && this.orderDetails.driver_info ? this.orderDetails.driver_info.phone : ''
        };
        this.phoneVisible = true;
      },
      // 获取订单详情
      getDetails() {
        this.loading = true;
        this.$get('Order/' + this.orderId, {})
          .then(data => {
            this.orderDetails = data;
            this.orderDetails.added_serviceStr = data.added_service.join('、');

              this.settlement_type_0=this.orderDetails.settlement_type==0;
              this.settlement_type_1=this.orderDetails.settlement_type==1;
              this.settlement_type_2=this.orderDetails.settlement_type==2;
            this.orderStatus = this.orderDetails.status;
            if (this.orderStatus == 6) {
              if (data.is_exceptional_deal == 1) {
                this.btnList[6] = [{
                  btnName: '处理结果',
                  type: 'primary',
                  clickName: 'resultsTreatment'
                }, {
                  btnName: '联系客服',
                  type: '',
                  clickName: 'getCustomerPhone'
                }]
              } else {
                this.btnList[6] = [{
                  btnName: '联系客服',
                  type: '',
                  clickName: 'getCustomerPhone'
                }]
              }
            }
            this.type[0] = this.orderDetails.delivery_type == 1 ? '竞价中' : '待接单';
            this.loading = false;
          }, error => {
            this.loading = false;
            this.$message.error(error);
          });
      },
      // 联系客服
      getCustomerPhone() {
        this.phoneItem = {
          title: '客服联系方式',
          phone: this.customer.phone
        };
        this.phoneVisible = true;
      },
    },
    destroyed() {
      clearInterval(this.timer);
    },
    created() {
      this.orderId = this.$route.query.orderId;
      this.getDetails();
      this.getGoodsType();
      this.getServicesType();
    },
    mounted() {

    }
  }
</script>

<style scoped lang='less'>
  .order_details {
    padding: 0 80px 0 20px;

    .modal {
      width: 100%;
      height: 100vh;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 10000;
      background: rgba(0, 0, 0, .8);
    }

    .modal_box {
      width: 1364px;
      position: fixed;
      top: 10px;
      left: 0;
      right: 0;
      margin: auto;
      max-height: calc(100vh - 20px);
      z-index: 10001;
      background: #fff;

      overflow-y: auto;
    }

    .modal_content {
      border: 1px solid #676767;
      color: #3B4047;
      padding: 40px;

      &_header {
        height: 80px;
        line-height: 80px;
        font-size: 36px;
        font-weight: 500;
        color: #3B4047;
        border-bottom: 1px solid #1D77FD;
        text-align: center;
      }

      .footer_first {
        padding: 31px 26px 22px 26px;
        display: flex;
        align-items: center;

        img {
          width: 80px;
          height: 80px;
          margin-right: 20px;
        }

        .footer_first_title {
          font-size: 24px;
          line-height: 33px;
          font-weight: 600;
          margin-bottom: 10px;
        }

        .footer_first_bo {
          display: flex;
          justify-content: space-between;

          div {
            font-size: 24px;
            line-height: 33px;
          }
        }
      }

      .footer_sec {
        padding: 0 26px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;

        &_box {
          width: 630px;
          padding: 28px 30px 31px 30px;
          background: #F7F9FC;
        }
      }

      .footer_title {
        font-size: 28px;
        display: flex;
        align-items: center;

        .footer_title_line {
          display: inline-block;
          width: 15px;
          height: 24px;
          border-radius: 8px;
          background: #1D77FD;
          margin-right: 10px;
        }

        span {
          color: #333;
          font-weight: 500;
        }

      }

      .text {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;

        &_label {
          display: inline-block;
          min-width: 204px;
          color: #999CA2;
          font-size: 22px;
          line-height: 33px;
        }

        &_value {
          display: inline-block;
          font-size: 22px;
          line-height: 33px;
          color: #000;
        }
      }

      .text1 {
        font-size: 22px;
        color: #D74242;
        line-height: 33px;
        margin-top: 10px;
      }

      .text_box {
        display: flex;
        justify-content: space-between;

        .text {
          width: 244px;
        }

        .text_label {
          min-width: 120px;
        }
      }
    }

    .pay_modal {
      .pay_modal_cbox {
        display: flex;
        align-items: center;
      }

      .pay_modal_wx {
        display: flex;
        align-items: center;
      }

      img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
      }
    }

    &_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;

      /deep/ .el-button {
        font-size: 14px;

      }

      span {
        font-size: 16px;
      }

      span.order_details_header_type {
        font-size: 20px;
        color: #1F9EFF;
        font-weight: 500;
        margin-left: 16px;
      }
    }

    &_address {
      width: 740px;
      background: #F7F9FC;
      padding: 23px 20px 25px 20px;
      margin-top: 14px;
      position: relative;

      &_line {
        position: absolute;
        width: 1px;
        height: 30px;
        border: 1px dashed #9EA7B4;
        top: 70px;
        left: 38px;
      }

      &_start {
        display: flex;
        align-items: center;

        &_logo {
          width: 38px;
          height: 38px;
          font-size: 18px;
          text-align: center;
          line-height: 38px;
          margin-right: 25px;
          border-radius: 4px;
          background: linear-gradient(314deg, #629FFF 0%, #D8E3F3 100%);
          color: #fff;
        }

        &_phone {
          font-size: 12px;
          color: #666666;
        }

        &_company {
          font-size: 16px;
          margin-top: 4px;
        }
      }

      &_end {
        display: flex;
        align-items: center;

        &_logo {
          width: 38px;
          height: 38px;
          font-size: 18px;
          text-align: center;
          line-height: 38px;
          margin-right: 25px;
          border-radius: 4px;
          background: linear-gradient(314deg, #20ABA2 0%, #D1FDFD 100%);
          color: #fff;
        }

        &_company {
          font-size: 16px;
          line-height: 38px;
        }
      }
    }

    &_msg {
      width: 740px;
      background: #F7F9FC;
      padding: 23px 20px 25px 15px;
      margin-top: 24px;

      .order_details_box {
        display: flex;
        justify-content: space-between;
      }

      &_left {
        width: 320px;
        margin-top: 17px;

        &_item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;

          &_title {
            font-size: 14px;
            color: #666;
          }

          &_value {
            max-width: 248px;
            font-size: 14px;
            color: #333;
          }
        }
      }

      &_right {
        width: 320px;
        margin-top: 17px;

        &_item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;

          &_title {
            font-size: 14px;
            color: #666;
          }

          &_value {
            max-width: 248px;
            font-size: 14px;
            color: #333;

            img {
              width: 69px;
              height: 69px;
              cursor: pointer;
            }
          }
        }
      }
    }

    &_cost {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      &_action {
        margin-top: 20px;
        display: flex;

        /deep/ .el-button {
          min-width: 82px;
        }

        // justify-content: space-between;
      }

      .order_details_cost_box {
        margin: 16px 0 10px 0;

        &_item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;

          &_title {
            font-size: 14px;
            color: #666;
          }

          &_value {
            max-width: 248px;
            font-size: 14px;
            color: #333;

            img {
              width: 69px;
              height: 69px;
            }
          }
        }
      }

      &_left {
        width: 360px;
        background: #F7F9FC;
        padding: 10px 20px 10px 15px;

        &_line {
          border: 1px dashed #E1E1E1;
        }

        &_all {
          font-size: 18px;
          color: #D74242;
          font-weight: 500;
          text-align: right;
          padding: 10px 0 10px 0;
        }
      }

      &_right {
        width: 360px;
        background: #F7F9FC;
        padding: 10px 20px 10px 15px;
      }
    }

    &_title {
      font-size: 16px;
      font-weight: 500;

    }
  }

  .title_2 {
   /* background-color: #409EFF; */
    color: #fff;
    padding: 5px;
    height: 34px;
  }

  .imtes_2 {
    padding: 10px 0px;
   /* border-bottom: 1px solid #6f6868; */
  }
  .gods1{
    position: relative;
    .gods1_prd{
      width: 20px;
      position: absolute;
      right: -30px;
      margin: auto;
      top: 30px;
    }
    .gods1_prd2{
      color: #000;
     width: 150px;
     height: 90px;
     position: absolute;
     right: 0px;
     margin: auto;
     bottom: 0px;
    /* border: 1px solid #000; */
     background-color: #fff;
     border-top: 0px;
     border-right: 0px;
    }


    .gods1_prd3{
       color: #000;
     width: 150px;
     height: 79px;
     position: absolute;
     right: 0px;
     margin: auto;
     top: 0px;
    /* border: 1px solid #000; */
     background-color: #fff;
     border-top: 0px;
     border-right: 0px;
    }
  }
  .bg-purple{
    text-indent: 40px;

  }
  .bg-purple_2{
    text-indent: 70px;

  }
</style>



// WEBPACK FOOTER //
// src/pages/orderDetails/orderDetails.vue